/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from './../request.js'

// MBB-单卡管理-列表
export function listCards(params) {
	return request({
		url: '/mbb/agent/resource/cards/list.do?',
		method: 'post',
		data: params
	})
}

// MBB-单卡管理-导入-type-67（文件导入或批量输入）
export function importCardsSync(data) {
	return request({
		url: '/mbb/agent/resource/cards/batchImportSync.do?',
		method: 'post',
		data,
		timeout: 20000,
		headers: { 'Content-Type': 'multipart/form-data' }
	})
}

// MBB-单卡管理-导出
export function exportCards(params) {
	return request({
		url: '/mbb/agent/resource/cards/export.do?',
		method: 'post',
		data: params
	})
}

// MBB-单卡管理-修改模式
export function updateMode(params) {
	return request({
		url: '/mbb/agent/resource/cards/updateMode.do?',
		method: 'post',
		data: params
	})
}

// MBB-单卡管理-删除
export function deleteCard(params) {
	return request({
		url: '/mbb/agent/resource/cards/delete.do?',
		method: 'post',
		data: params
	})
}


